var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonQuery',{attrs:{"formTitle":_vm.formTitle,"infoArray":_vm.infoArray,"isLoading":_vm.isLoading},scopedSlots:_vm._u([{key:"result-content",fn:function(){return [_c('ResultContent',{attrs:{"resultTemplates":_vm.resultTemplates}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }